/**
 * TanStack Router: /painel-colaboradores
 *
 * Read-only workforce dashboard — KPI cards, charts, employee table.
 * Restricted to management roles (admin, rh, diretor-tecnico, diretor-financeiro).
 *
 * @see docs/architecture/PAINEL-COLABORADORES-READONLY-VIEW.md
 */
import { createFileRoute } from '@tanstack/react-router'
import PainelColaboradoresPage from '@/app/painel-colaboradores/page'

export const Route = createFileRoute('/_auth/painel-colaboradores')({
  component: PainelColaboradoresPage,
})
